import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  public selectedId: BehaviorSubject<string> = new BehaviorSubject<string>("")

}
